module.exports = __webpack_public_path__ + "b975a6f8c0d8f6f6f054b7ab46b7aba5.jpg";